const imagesData = [
  {
    id: 1,
    title: 'Odbicia',
    src: require('../assets/images/ob1.jpg'),
    description: 'Liliana Kużdowicz - Odbicia (1992)'
  },
  {
    id: 2,
    title: 'Impresja pejzażowa',
    src: require('../assets/images/ob2.jpg'),
    description: 'Liliana Kużdowicz - Impresja pejzażowa'
  },
  {
    id: 3,
    title: 'Nad jeziorem',
    src: require('../assets/images/ob3.jpg'),
    description: 'Liliana Kużdowicz - Nad jeziorem'
  },
  {
    id: 4,
    title: 'Na temat pejzażu III',
    src: require('../assets/images/ob4.jpg'),
    description: 'Liliana Kużdowicz - Na temat pejzażu III (1996)'
  },
  {
    id: 5,
    title: 'Pejzaż w deszczu',
    src: require('../assets/images/ob5.jpg'),
    description: 'Liliana Kużdowicz - Pejzaż w deszczu (1978)'
  },
  {
    id: 6,
    title: 'Błędne skały',
    src: require('../assets/images/ob6.jpg'),
    description: 'Liliana Kużdowicz - Błędne skały (1976)'
  },
  {
    id: 7,
    title: 'Impresja pejzażowa III',
    src: require('../assets/images/ob7.jpg'),
    description: 'Liliana Kużdowicz - Impresja pejzażowa III (1987)'
  },
  {
    id: 8,
    title: 'Motyw pejzażowy',
    src: require('../assets/images/ob8.jpg'),
    description: 'Liliana Kużdowicz - Motyw pejzażowy (2000)'
  },
  {
    id: 9,
    title: 'Pejzaż morski',
    src: require('../assets/images/ob9.jpg'),
    description: 'Liliana Kużdowicz - Pejzaż morski'
  },
  {
    id: 10,
    title: 'Na temat pejzażu',
    src: require('../assets/images/ob10.jpg'),
    description: 'Liliana Kużdowicz - Na temat pejzażu'
  },
  {
    id: 11,
    title: 'Na temat pejzażu II',
    src: require('../assets/images/ob11.jpg'),
    description: 'Liliana Kużdowicz - Na temat pejzażu II'
  },
];

export default imagesData;
